import React, { Component } from '../../lib/react';
import { Button } from 'antd';

import Events from "../../services/events";

import PageHeader from '../../components/Modules/PageHeader';

import FilterPanel from "../../components/Modules/FilterPanel";

import MyProfileTabsContent from './MyProfileTabsContent';

import './myProfile.less'

class MyProfile extends Component {

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  }

  render(){
    const { events, channels, subscriptions, user, location } = this.props;

    return (
      <React.Fragment>
        <PageHeader
          title="My Profile"
          isHideBackButton={true}
          extra={
            <div className="search-form">
              <FilterPanel filter={this.filterBy} deviceType />
            </div>
          }
          extraMobile={
            <Button type="primary" shape="circle" icon="search" />
          }
          mobileTitleSearch="User search"
          mobileTypeSearch="user"
        />
        <MyProfileTabsContent
          user={user}
          location={location}
          channels={channels}
          subscriptions={subscriptions}
          events={events}
        />
      </React.Fragment>
    )
  }
}

export default MyProfile;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/index.js